import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { WA_PHYSICS } from '../core/constants';

export const WeaponTeleport: WeaponDefinition = {
  id: 'teleport',
  name: 'Teleport',
  icon: 'teleport.png',
  category: 'utility',
  maxAmmo: 2,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, target } = ctx;

    if (!target) {
      return {
        success: false,
        message: 'Select a destination',
      };
    }

    if (target.y > WA_PHYSICS.WORLD.HEIGHT - WA_PHYSICS.WORLD.WATER_LEVEL - 20) {
      return {
        success: false,
        message: 'Cannot teleport into water',
      };
    }

    worm.position.x = target.x - WA_PHYSICS.WORM.WIDTH / 2;
    worm.position.y = target.y - WA_PHYSICS.WORM.HEIGHT;
    worm.velocity.x = 0;
    worm.velocity.y = 0;

    return {
      success: true,
      entities: [],
      message: 'Teleported!',
    };
  },
};
